/** Theme tokens — aligned with Our Memories landing / login (ink & stone). */
export const THEME = {
  primary: '#0f172a',
  primaryLight: '#2563eb',
  background: 'var(--sd-page-bg)',
  cardBackground: 'var(--sd-card)',
  heroBackground: 'var(--sd-hero-bg)',
  border: 'var(--sd-border)',
  textPrimary: 'var(--sd-text-primary)',
  textSecondary: 'var(--sd-text-secondary)',
  success: '#2563eb',
  shadow: 'var(--sd-shadow-medium)',
  primaryHover: '#2563eb',
  cardBg: 'var(--sd-card)',
  textMuted: 'var(--sd-text-muted)',
  borderLight: 'var(--sd-border-light)',
  heroGradient: 'var(--sd-hero-bg)',
  shadowLight: 'var(--sd-shadow)',
  shadowMedium: 'var(--sd-shadow-medium)',
  shadowHeavy: 'var(--sd-shadow-medium)',
  glassBg: 'var(--sd-glass)',
  glassBgLight: 'var(--sd-glass)',
  glassBgLighter: 'var(--sd-glass)',
  chartColors: ['#0f172a', '#2563eb', '#64748b', '#94a3b8', '#e2e8f0'],
  online: '#2563eb',
  offline: 'var(--sd-text-muted)',
  warning: '#8a5a2b',
  hoverOverlay: 'rgba(20,18,16,0.06)',
  activeScale: 'scale-[0.98]',
  hoverScale: 'scale-[1.02]',
  tooltipBg: 'var(--sd-tooltip-bg)',
  tooltipBorder: 'var(--sd-tooltip-border)',
  statusNewBg: 'var(--sd-status-new-bg)',
};
